import { FlexRow, Text, Rating } from '@epam/loveship'
import { PointReviewResponse } from '../../../../../../constants/types'
import css from './PointCardReview.module.scss'

interface PointCardReviewProps {
  reviews: PointReviewResponse[]
}

export const PointCardReview: React.FC<PointCardReviewProps> = ({
  reviews,
}) => {
  const rating = !reviews.length
    ? 5
    : reviews.reduce((acc, current) => acc + current.rating, 0) / reviews.length
  return (
    <FlexRow>
      <Rating
        cx={css.star}
        value={rating}
        isReadonly
        size={18}
        onValueChange={() => undefined}
      />

      <Text cx={css.dateText} font="sans">
        {rating.toFixed(1)}
      </Text>
      <Text cx={css.dateText} font="sans">
        ({reviews.length})
      </Text>
    </FlexRow>
  )
}
